module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 87
// module chunks = 129